import { render, staticRenderFns } from "./HistoricoInativacaoList.vue?vue&type=template&id=2c93caf6&scoped=true"
import script from "./HistoricoInativacaoList.vue?vue&type=script&lang=js"
export * from "./HistoricoInativacaoList.vue?vue&type=script&lang=js"
import style0 from "./HistoricoInativacaoList.vue?vue&type=style&index=0&id=2c93caf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c93caf6",
  null
  
)

export default component.exports